module.exports = "data:image/gif;base64,R0lGODlhEAAQANUAAAAAAP///7OvstPO2eDg8KCowLC40NDY8KCw0LDA4DBIYJCowKC40JCgsKCwwLDA0MDQ4MDI0NDY4ODo8PD4/51bJaWEadqzlsuYedK4qa5yU72bi71jQpA1IbJMQ8ZaUq9raZkAAJkzM8yZmfDw8JmZmXNzc////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAACcALAAAAAAQABAAAAZxwJNwSBSOTMWkUFOxKIugTyjzHHo4HQ11mOh2HxpN54IpJgLoAMjTqZSLj/RatIgokgb0xuMJNBSARQwBAx0gaQ1/RQgBJQJoFBMEikQOaQEUJBMHlEMFaImaBBKdQguJgIkHEKUnf3cnqa9VQ4G0tEEAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/edit.gif
// module id = 9a71
// module chunks = 1